"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Indicator =
/** @class */
function (_super) {
  __extends(Indicator, _super);

  function Indicator() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.updateIndicatorConfigured = function () {
      Indicator.updateIndicator(_this.indicatorRef, _this.props.selectedItemRefCallback(), _this.props.containerRefCallback(), _this.props.horizontal, _this.props.hide && _this.props.hide(), _this.props.fullSizeWhenUnselected);
    };

    return _this;
  }

  Indicator.prototype.componentDidMount = function () {
    var _this = this;

    utils_1.WindowEvents.addResizeCallback(this.updateIndicatorConfigured);

    if (document.fonts) {
      document.fonts.ready.then(function () {
        // update underline once the fallback font is replaced by the webfont
        _this.updateIndicatorConfigured();
      });
    } else {
      setTimeout(function () {
        // assume that the font is loaded quickly
        _this.updateIndicatorConfigured();
      }, 300);
    }
  };

  Indicator.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeResizeCallback(this.updateIndicatorConfigured);
  };

  Indicator.prototype.componentDidUpdate = function () {
    this.updateIndicatorConfigured();
  };

  Indicator.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        id = _a.id;
    return React.createElement(React.Fragment, null, this.props.withHelperLine && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "helperindicator"
    }), React.createElement("div", {
      id: id,
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "indicator " + CSSPrefix_1.lsgPre + "indicator" + (this.props.horizontal ? "__horizontal" : "__vertical"), className]),
      ref: function ref(r) {
        return _this.indicatorRef = r;
      }
    }));
  };

  Indicator.updateIndicator = function (indicatorElm, selectedItemElm, containerElm, horizontal, hide, fullSizeWhenUnselected) {
    if (horizontal === void 0) {
      horizontal = false;
    }

    if (hide === void 0) {
      hide = false;
    }

    if (fullSizeWhenUnselected === void 0) {
      fullSizeWhenUnselected = false;
    }

    if (indicatorElm) {
      if (selectedItemElm && containerElm) {
        // determine indicator offset and width
        var styles = window.getComputedStyle(selectedItemElm); // const containerStyles = window.getComputedStyle(containerElm);

        var parentElm = containerElm.parentElement;
        var parentElmStyles = window.getComputedStyle(parentElm);

        if (horizontal) {
          var translateX = selectedItemElm.parentElement.offsetLeft + parseInt(styles.paddingLeft, 10);
          var scale = parseInt(styles.width, 10) / containerElm.offsetWidth;
          indicatorElm.style.transform = "translateX(" + translateX + "px) scale(" + scale + ", 1)";
        } else {
          var translateY = selectedItemElm.offsetTop - (parseInt(parentElmStyles.height, 10) + parseInt(parentElmStyles.paddingTop, 10) + parseInt(parentElmStyles.paddingBottom, 10));
          var scale = selectedItemElm.offsetHeight;
          indicatorElm.style.transform = "translateY(" + translateY + "px) scale(1, " + scale + ")";
        }

        indicatorElm.style.visibility = !hide ? "visible" : "hidden";
      } else {
        indicatorElm.style.transform = fullSizeWhenUnselected && horizontal ? "translateX(0px) scale(1, 1)" : "translateX(0px) scale(0, 1)";
        indicatorElm.style.visibility = fullSizeWhenUnselected && horizontal ? "visible" : "hidden";
      }
    }
  };

  return Indicator;
}(React.Component);

exports.Indicator = Indicator;